import React from 'react';
import { Box, Container, Flex } from '@chakra-ui/react';

import CoreSubtitle from './core/CoreSubtitle';
import CoreParagraph from './core/CoreParagraph';
import CoreTitle from './core/CoreTitle';

const data = [
  {
    subtitle: '',
    newLine: false,
    paragraph: `The website www.nonilnear.ro is an online platform that Nonlinear uses to communicate with the public. The access to, and the use of the website www.nonlinear.ro are subject to terms and conditions (hereinafter referred to as the “Legal Notice”). This website is property of NONLINEAR SRL, an IT company established in Romania, having the registered office in Galați, Bld. Marea Unire Nr. 15, Bl. U4, Spatiu Comercial 2, Galati. Phone: 0336 401 269. Email: contact@nonlinear.ro . By accessing and using the website www.nonlinear.ro, you hereby accept the Legal Notice. The representatives of the firm holding the website reserve the right to unilaterally amend this Legal Notice without prior notice to the website's users. Your continued use of the website www.nonlinear.ro leads by default to acceptance of the Legal Notice thus amended. In this regard, before accessing any page contained in the website www.nonlinear.ro, the users are under the obligation to read the Legal Notice as this may be amended from time to time.`,
  },
  {
    subtitle: '',
    newLine: false,
    paragraph: `Nonlinear SRL, created the www.nonlinear.ro website to personally inform all its customers. Your use of this website is subject to compliance with the general conditions of access and use detailed below, as well as to compliance with all applicable laws. When you access the website, when you go through it and use it, you implicitly and unconditionally accept the general conditions detailed below, which prevail over any other agreement you may have with Nonlinear SRL, with all the members of its commercial network or only with some of them.`,
  },
  {
    subtitle: 'Contents:',
    newLine: true,
    paragraphs: [
      ` •	Collection and processing of personal data;`,
      ` •	Copyrights;`,
      ` •	Trade name/mark, and content of the website;`,
      ` •	Guarantee and the safeguard clause for the use of the website;`,
      ` •	Governing law;`,
      ` •	Miscellaneous.`,
    ],
  },
  {
    subtitle: 'Collection and processing of personal data',
    newLine: true,
    paragraphs: [
      `The personal data shall be stored in compliance with Regulation (EU) 2016/679 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) (hereinafter referred to as the “Regulation”) only when you grant us the right to process it.`,
      `As your agreement to the use of Your personal data for the aforementioned purposes may also include transmission thereof to our partners, the data collected may be directed also to such third parties.`,
      `Data is collected to be processed for purposes related to the products and services offered by the firm, such as contacting you (including by mail, email, fax, text message or phone) in connection with their request for goods or services. The information recorded is intended to be used by the controller, and may be disclosed only to the following recipients: you, the processor, and the contractual partners of the controller.`,
    ],
  },
  {
    subtitle: '1. Your rights',
    newLine: true,
    paragraphs: [
      `The Regulation grants the persons the personal data of whom is processed a number of rights. Thus, in addition to the currently existing rights, there is also the right to data portability, or to erasure of the data. Please find below a brief description of your rights:`,
      `The right of access means that you have the right to obtain from us confirmation as to whether or not personal data concerning you is being processed, and, where that is the case, access to the personal data and information about the manner in which data is processed.`,
      `The right to data portability refers to (i) the right to receive the personal data in a structured, commonly used and machine-readable format, and (ii) the right to have this data transmitted to another controller, where technically feasible. The right to object concerns the right to object to personal data processing when such processing is necessary for the performance of a task carried out in the public interest, or regards a legitimate interest of the controller.`,
      `The right to rectification regards correction, without undue delay, of any inaccurate personal data. Such rectification shall be given notice of to any recipient the date was sent to, unless this proves impossible or involves disproportionate effort.`,
      `The right to erasure means that you have the right to obtain from the us the erasure of personal data concerning you without undue delay where one of the following grounds applies: this is no longer necessary in relation to the purposes for which it was collected or otherwise processed; you withdraw your consent, and there is no other legal ground for the processing; you object to processing, and there are no overriding legitimate grounds for the processing; the personal data have been unlawfully processed; the personal data have to be erased for compliance with a legal obligation; the personal data have been collected in relation to the offer of information society services.`,
      `By accessing our website, the following data, but without limitation thereto, may be processed:`,
      `•	The IP address of the computer used for access purpose;`,
      `•	The date and time of the accessing or request;`,
      `•	The name of the page/file accessed;`,
      `•	The browser used by the user, including the browser's version;`,
      `•	The operation system used by the user;`,
      `•	In this context, cookies are also used.`,
      `Cookies are text files saved on the computer of the website's visitor, thus allowing recognition of an anonymous user. This website uses cookies in order to execute a more accurate protocol of the website accessing. You may disable the cookies on this website at any time.`,
      `Please be advised that, if you disable the cookies, the functionalities of the website may be restricted.`,
    ],
  },
  {
    subtitle: '2. Copyright',
    newLine: true,
    paragraphs: [
      `The content and structure of the website www.nonlinear.ro are property of Nonlinear SRL, and are protected under Law no. 8/1996 on copyright and related rights, Law no. 83/2014 on service inventions, Law no. 64/1991 on patents, Law no. 11/1991 on fighting against unlawful competition, as well as any other legal provisions in effect (regulations regarding industrial works, legislation applicable to distinguishing marks, etc.).`,
      `Any unauthorized use of the content of this website may infringe the afore-listed laws, as well as any other legal provisions. Any rights not granted are reserved as these appear in the content of the website.`,
      `Any reproduction, transfer, share or storage of parts of the website, or its entire content, irrespective of the means employed, without the prior written agreement of the holder of the website www.nonlinear.ro, is prohibited. This does not apply shares on social networks, and shares for advertising purposes alone.`,
    ],
  },
  {
    subtitle: '3. Trade name/mark, and content of the website www.nonlinear.ro',
    newLine: true,
    paragraphs: [
      `All trade names, trademarks, logos, and images displayed on this website are property of Nonlinear. The access to this website does not grant the right to use its content without prior written agreement.`,
    ],
  },
  {
    subtitle:
      '4. Guarantee and the safeguard clause for the use of the website www.nonlinear.ro',
    newLine: true,
    paragraphs: [
      `Nonlinear does not guarantee that the access to the website www.nonlinear.ro and its content will not be free of interruptions or errors. The website and its content are offered for information and without any guarantees, including, but without limitation to the availability, accuracy, security and correctness of the information. Furthermore, the website may contain errors or other mistakes, inaccuracies or typing errors due to the changes in content, layout and services.`,
      `The information on the website may be outdated, and Nonlinear assumes no commitment whatsoever to have such updated.`,
      `In the event that any material under copyright is published on the website www.nonlinear.ro, or such publication occurs in violation of the law, please let us know, and we will remove it forthwith.`,
      `Nonlinear assumes no liability whatsoever for any viruses or any breakdowns that could affect the IT equipment (computer, notebooks, tablets, phones, etc.), or any other assets facilitating the access of the website www.nonlinear.ro further to such access.`,
    ],
  },
  {
    subtitle: '5. Governing law',
    newLine: true,
    paragraphs: [
      `Nonlinear controls this website from the territory of Romania. Thus, all the information available on the website www.nonlinear.ro is considered to be supplied in Romania, and the users thereof are to subject themselves to the legal regulations of the Romanian State.`,
    ],
  },
  {
    subtitle: '6. Miscellaneous',
    newLine: true,
    paragraphs: [
      `Should any provision of this Legal Notice become or be declared null or unenforceable, this shall not affect the validity and enforceability of the remaining provisions hereof.`,
      `This Legal Notice sets out the AGREEMENT between You and Nonlinear, as controller of the website www.nonlinear.ro, as regards acceptance of the terms and conditions.`,
      `In the event that a person does not agree to the terms and conditions laid down at items 2-5 above, he/she is under the obligation to discontinue any use of the website.`,
      `The privacy policy and information on the safety of our customers' data can be found at the page: Private Policy.`,
    ],
  },
  {
    subtitle: 'Contact',
    newLine: true,
    paragraphs: [
      `Company name: Nonlinear SRL`,
      `Address: Bld. Marea Unire Nr. 15, Bl. U4, Spatiu Comercial 2, Galati`,
      `Phone: 0336 401 269`,
    ],
    emailConfig: {
      preLabel: 'Email: ',
      email: 'contact@nonlinear.ro',
    },
  },
];

const TermsAndConditions = () => {
  return (
    <Container
      maxWidth={{
        base: '85%',
        sm: '85%',
        md: '85%',
        lg: '75%',
        xl: '70%',
        '2xl': '70%',
      }}
    >
      <CoreTitle
        text=" Nonlinear Terms and Conditions"
        styleProps={{ mb: 6 }}
      />

      {data.map((item, index) => (
        <div key={index}>
          {item.subtitle ? (
            <Box textAlign="left" fontWeight="bold" mb="4" mt='8'>
              <CoreSubtitle text={item.subtitle} />
            </Box>
          ) : (
            <></>
          )}

          {item.newLine ? (
            <>
              {item.paragraphs.map((paragraph, indexP) => (
                <div key={indexP}>
                  <CoreParagraph text={paragraph} />
                  <br />
                </div>
              ))}
            </>
          ) : (
            <>
              <CoreParagraph text={item.paragraph} />
              <br />
            </>
          )}

          {item.emailConfig && item.emailConfig.email ? (
            <Flex gridGap="1">
              {item.emailConfig.preLabel ? (
                <CoreParagraph text={item.emailConfig.preLabel} />
              ) : (
                <></>
              )}

              <a href={`mailto:${item.emailConfig.email}`}>
                <CoreParagraph
                  text={item.emailConfig.email}
                  styleProps={{
                    _hover: {
                      textDecoration: 'underline',
                    },
                  }}
                />
              </a>
            </Flex>
          ) : (
            <></>
          )}
        </div>
      ))}
    </Container>
  );
};

export default TermsAndConditions;
